import { confirmSwal } from '@/components/utils/common';
import { aiorder_status_update } from '@/components/utils/common_func_axios';
import eventBus from '@/components/utils/eventBus';

function DOMLoaded() {
	console.info('AiorderJS-DOMLoaded()');

	document.querySelectorAll('.teethTab li').forEach((tab, index) => {
		tab.addEventListener('click', function () {
			handleTeethTabClick(index + 1);
		});
	});

	document.addEventListener('click', function (event) {
		// handleTeethTabClick(event);
		// handleTeethCheckboxClick(event);
	});

	setupOrderDateEvents();
	setupCheckboxToggle();
	setupArrowNavigation();
}

function handleTeethTabClick(tabNumber) {
	if (tabNumber === 1) {
		toggleTeethTab(['.r_teeth1', '.r_teeth2']);
	} else if (tabNumber === 2) {
		toggleTeethTab(['.r_teeth1', '.r_teeth2', '.r_teeth3', '.r_teeth4']);
	} else if (tabNumber === 3) {
		toggleTeethTab(['.r_teeth3', '.r_teeth4']);
	}
}

function toggleTeethTab(checkboxClasses) {
	checkboxClasses.forEach(cls => {
		document.querySelectorAll(`${cls} input[type="checkbox"]`).forEach(checkbox => {
			checkbox.checked = !checkbox.checked;
			checkbox.parentElement.classList.toggle('active', checkbox.checked);
		});
	});
}

/*
function handleTeethCheckboxClick(event) {
	if (event.target.matches('.r_teeth input[type="checkbox"]')) {
		const checkbox = event.target;
		const parentDiv = checkbox.closest('.r_teeth');
	
		if (parentDiv.classList.contains('r_teeth1') || parentDiv.classList.contains('r_teeth2')) {
			if (!checkbox.checked) {
				document.querySelector('.teethTab li:nth-of-type(1)').classList.remove('active');
				document.querySelector('.teethTab li:nth-of-type(2)').classList.remove('active');
			}
		}
	
		if (parentDiv.classList.contains('r_teeth3') || parentDiv.classList.contains('r_teeth4')) {
			if (!checkbox.checked) {
				document.querySelector('.teethTab li:nth-of-type(2)').classList.remove('active');
				document.querySelector('.teethTab li:nth-of-type(3)').classList.remove('active');
			}
		}
	}
}
*/

function setupOrderDateEvents() {
	document.querySelectorAll('#data_orderForm input.order_date').forEach(element => {
		element.dispatchEvent(new Event("load"));
	});
}

function setupArrowNavigation() {
	const arrowPre = document.querySelector(".box2_date .arrow_pre");
	const arrowNext = document.querySelector(".box2_date .arrow_next");

	if (arrowPre) {
		arrowPre.addEventListener("click", () => changeOrderDate(-1));
	}

	if (arrowNext) {
		arrowNext.addEventListener("click", () => changeOrderDate(1));
	}
}

function changeOrderDate(monthChange) {
	const orderTable = document.getElementById("order_table");
	const dateInput = document.getElementById("Ostatus_date");
	if (!dateInput) return;

	//if (orderTable) orderTable.innerHTML = "";

	let currentDate = new Date(dateInput.value);
	currentDate.setMonth(currentDate.getMonth() + monthChange);
	dateInput.value = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`;
	//dateInput.dispatchEvent(new Event("change"));
	const event = new CustomEvent('dateChanged', { detail: dateInput.value });
	dateInput.dispatchEvent(event);
}

function setupCheckboxToggle() {
	const chkAll = document.getElementById("chk_all");
	if (chkAll) {
		chkAll.addEventListener("click", function () {
			const checkboxes = document.querySelectorAll("input[type='checkbox'].chk");
			checkboxes.forEach(checkbox => {
				checkbox.checked = chkAll.checked;
			});
		});
	}
}

async function statusChange(event, aiorder_id, aiorder_no, before, accType) {
	let newStatus = event.target.value; // 새로 선택된 상태 값

	var prev_value = new Array();
	prev_value[aiorder_id] = newStatus;

	const status_text = {
		"ords1": "AI 기공주문서 접수",
		"ords2": "AI 기공주문서 확인",
		"ords3": "출고 완료",
		"ords4": "주문 취소"
	};
	const msg = `정말 해당 AI 기공주문서의 상태를 [${status_text[newStatus]}](으)로 변경하시겠습니까?${(newStatus === "ords3" || newStatus === "ords4") ? "\n이 작업은 취소할 수 없습니다." : ""}`;

	if (before === 'ords3' || before === 'ords4') {
		toast.fire({
			icon: "error",
			title: '변경이 불가합니다.'
		});

		eventBus.emit('update-status', prev_value[aiorder_id]);
		return false;
	}

	const is_confirm = await confirmSwal('주문상태변경 확인', msg, 'nl');
	if (!is_confirm) {
		event.target.value = before;
		// 240731 부모페이지 aiorder_view.vue 에 반영되도록
		eventBus.emit('update-status', before);
		return false;
	}

	const data = {
		aiorder_id: aiorder_id,
		order_status: newStatus,
		aiorder_no: aiorder_no
	};

	const result = await aiorder_status_update(data);

	if (result.result === 'success') {
		prev_value[aiorder_id] = newStatus;

		// 240731 부모페이지 aiorder_view.vue 에 반영되도록
		eventBus.emit('update-status', newStatus);
		
		/*
		if (newStatus === "ords3" || newStatus === "ords4") {
			obj.disabled = true;
		}
		*/

		toast.fire({
			icon: "success",
			title: result.msg,
		});
		return true;

	} else {
		event.target.value = before;
		eventBus.emit('update-status', before);

		toast.fire({
			icon: "error",
			title: result.msg,
		});
		return false;
	}
}

function setStatusColor(event, ) {
	const obj = event.target;
	console.log(obj.value);
	/*
	$this.find('option').each(function() {
		$(this).css('bg',$(this).data('bg'));
		$(this).css('color',$(this).data('color'));
	});
	*/
}
/*
function changeDeadline(obj, a_id) {
	if (!obj || typeof obj.value === 'undefined') return false;

	if (confirm("해당 AI 기공주문서의 예상 완료일을 변경하시겠습니까?")) {
		$.ajax({
			type: "POST",
			url: "/dental_common/ajax.order_deadline.php",
			data: { a_id, deadline: obj.value },
			cache: false,
			async: false,
			dataType: "json",
			success: function (data) {
				if (data.error) {
					alert(data.error);
					return false;
				}
				$(obj).parent().parent().find(".d-day.zero").html("D-" + data.dday);
				prev_deadline_value[a_id] = obj.value;
			}
		});
		return true;
	} else {
		obj.value = prev_deadline_value[a_id];
	}

	return false;
}
*/
/*
function setDeadline(obj, a_id) {
	if (!obj || typeof obj.value === 'undefined') return;
	prev_deadline_value[a_id] = obj.value;
}
*/
/*
function orderTable(mbId) {
	const dateInput = document.getElementById("Ostatus_date");
	if (!dateInput) return false;
	const dateymd = dateInput.value;

	$.ajax({
		type: "POST",
		url: "/dental_common/ajax.order_table_list.php",
		data: { date: dateymd, lab_mb_id: mbId },
		cache: false,
		async: false,
		dataType: "json",
		success: function (data) {
//console.debug(data);
			if (data.error) {
				alert(data.error);
				return false;
			}
			const orderTable = document.getElementById("order_table");
			if (!orderTable) return false;
			orderTable.innerHTML = "";
			const html = document.getElementById("order_table_list_template").value;

			data.list.forEach(item => {
				let list = html;
				const [year, month, day] = item.date.split("-");

				list = list.replace(/\[\[year\]\]/gi, year)
					.replace(/\[\[month\]\]/gi, month)
					.replace(/\[\[day\]\]/gi, day)
					.replace(/\[\[today_order\]\]/gi, item.today_order)
					.replace(/\[\[today_remake\]\]/gi, item.today_remake)
					.replace(/\[\[out_soon\]\]/gi, item.out_soon)
					.replace(/\[\[today_out_complete\]\]/gi, item.today_out_complete);

				if (item.today === true) {
					list = list.replace(/\[\[active\]\]/gi, " class='active'");
				} else {
					list = list.replace(/\[\[active\]\]/gi, "");
				}

				orderTable.insertAdjacentHTML('beforeend', list);
			});

			dateInput.value = dateInput.value.slice(0, 7);
		}
	});
}
*/

function leftPad(value) {
	return value >= 10 ? value : `0${value}`;
}

function toStringByFormatting(source, delimiter = '-') {
	const year = source.getFullYear();
	const month = leftPad(source.getMonth() + 1);
	const day = leftPad(source.getDate());
	return [year, month, day].join(delimiter);
}

export {
	DOMLoaded, leftPad, toStringByFormatting, statusChange,
	//changeDeadline,
	//setDeadline,
	//orderTable
};